// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Abel);"]);
// Module
exports.push([module.id, ".spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n  width: 100%; }\n\n.indicator {\n  width: 100px; }\n", ""]);
// Exports
module.exports = exports;
